export default __webpack_public_path__ + "static/media/whyChooseUsIcon6.d943e4b9.webp";